import { render, staticRenderFns } from "./AddEditDocument.vue?vue&type=template&id=10deca75&"
import script from "./AddEditDocument.vue?vue&type=script&lang=js&"
export * from "./AddEditDocument.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports